import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllService } from '../../../slices/services/thunk';
import { fetchAllOffers } from '../../../slices/offer/thunk';
import { getAllResources } from '../../../slices/resources/thunk';
import moment from 'moment';
import { termValidity } from '../../Pricings/Offers/constants/checkEmptyFields';
import { fetchCustomer } from '../../../slices/customer/fetchcustomer/thunk';

export const offerServiceData = (setLoading, customerIdPath) => {
    const dispatch = useDispatch();
    const [offerResponse, setOfferResponse] = useState([]);
    const [serviceResponse, setServiceResponse] = useState([]);
    const [customerData, setCustomerData] = useState(null);
    const [resourceData, setResourceData] = useState("");

    useEffect(() => {
        dispatch(fetchAllOffers(setLoading));
        dispatch(getAllService(setLoading));
        if (customerIdPath !== "create-customer") {
            dispatch(fetchCustomer(setLoading, customerIdPath));
        }
        dispatch(getAllResources(setLoading));
    }, [dispatch, setLoading]);

    const offer = useSelector((state) => state.Offer.offer);
    const serviceData = useSelector((state) => state.Services.services);
    const customerInfo = useSelector((state) => state.FetchCustomer.fetchCustomer.customerInfo);
    const resource = useSelector((state) => state.Resources.resources);
    useEffect(() => {
        const sampleOfferResponse = offer;
        const sampleServiceResponse = serviceData;
        setOfferResponse(sampleOfferResponse);
        setServiceResponse(sampleServiceResponse);
        setCustomerData(customerInfo);
        setResourceData(resource)
    }, [offer, serviceData, resource, customerInfo]);

    return { offerResponse, serviceResponse, resourceData, customerData };
}

export const groupedFunction = (offerResponse, serviceResponse, resourceData, setResult, customerIdPath, customerData) => {
    if (offerResponse.length > 0 && serviceResponse.length > 0) {
        let groupedResults = {}
        if (customerIdPath !== "create-customer") {
            groupedResults = {
                baseOffers: {}
            };
        }
        offerResponse?.forEach((offer) => {
            const matchingService = serviceResponse.find((service) => service.serviceCode === offer.serviceCode);
            let provAttr = []
            if (matchingService) {
                serviceResponse.forEach((value, index) => {
                    if (offer.serviceCode === serviceResponse[index].serviceCode) {
                        provAttr.push(serviceResponse[index].provisioningAttributes)
                    }
                })
            }
            const serviceName = matchingService ? matchingService.name : '';
            const category = offer?.addOnOffer ? 'addOnOffers' : 'baseOffers';
            if (customerIdPath === "create-customer") {
                if (!groupedResults[serviceName]) {
                    groupedResults[serviceName] = [];
                }
            }
            else {
                if (!groupedResults[category]) {
                    groupedResults[category] = {};
                }
                if (!groupedResults[category][serviceName]) {
                    groupedResults[category][serviceName] = [];
                }
            }
            const validityFrom = moment(offer.validity.from).format('MMM DD,YYYY');
            const validityTo = moment(offer.validity.to).format('MMM DD,YYYY');
            const termValidityLabel = offer.subscriptionValidity && offer.subscriptionValidity.relativeEndTimeUnit
                ? `${termValidity(
                    offer.subscriptionValidity.relativeEndTimeUnit,
                    offer.subscriptionValidity.relativeEndTimeValue
                )?.props?.children[0]}${termValidity(
                    offer.subscriptionValidity.relativeEndTimeUnit,
                    offer.subscriptionValidity.relativeEndTimeValue
                )?.props?.children[1]}`
                : "Never Ending";
            const totalChargeAmount = offer.Charges ? offer.Charges.reduce((sum, charge) => sum + charge.amount, 0) : 0;
            const unitPrice = offer.Charges ? offer.Charges.reduce((sum, charge) => sum + charge.amount, 0) : 0;
            const subTotal = offer.Charges ? offer.Charges.reduce((sum, charge) => sum + charge.amount, 0) : 0;
            let groupedObject
            if (customerIdPath === "create-customer") {
                groupedObject = groupedResults[serviceName]
            } else {
                groupedObject = groupedResults[category][serviceName]
            }

            let chargeCard = []
            offer?.Charges?.forEach((charge)=>{
                resourceData?.forEach((resource)=>{
                    if(resource.resourceId === charge?.resourceId){
                        let jsonObj = {
                            currencySymbol: resource?.currencySymbol,
                            chargeAmount: charge?.amount,
                            oneTimeorRecurring: charge?.type === 1 ? "One Time" : "Recurring"
                        }
                        chargeCard.push(jsonObj)
                    }
                })
            })
            let grantCard = []
            offer?.Grants?.forEach((grant)=>{
                resourceData?.forEach((resource)=>{
                    if(resource.resourceId === grant?.resourceId){
                        let jsonObj = {
                            uom: resource?.unitofmeasurement,
                            name: resource?.name,
                            grantAmount: grant?.amount,
                            oneTimeorRecurring: grant?.type === 1 ? "One Time" : "Recurring"
                        }
                        grantCard.push(jsonObj)
                    }
                })
            })

            groupedObject.push({
                offerCode: offer.offerCode,
                offerName: offer.offerName,
                validityFrom: validityFrom,
                validityTo: validityTo,
                termValidity: termValidityLabel,
                Grants: offer.Grants ? offer.Grants : [],
                Charges: offer.Charges ? offer.Charges : [],
                Usage: offer.usageRatePlan ? offer.usageRatePlan : [],
                serviceName: serviceName,
                provisioningAttributes: offer?.attributes ? offer?.attributes : [],
                totalChargeAmount: totalChargeAmount,
                unitPrice: unitPrice,
                subTotal: subTotal,
                description: offer.description,
                ...(customerIdPath !== "create-customer" && {
                    CustomerId: customerIdPath,
                    CustomerName: customerData?.firstName
                }),
                categories: offer?.categories || [],
                ChargeCard: chargeCard,
                GrantCard: grantCard
            });
            return groupedObject;
        }, {});
        if (customerIdPath === "create-customer") {
            setResult(Object.entries(groupedResults));
        }
        else {
            setResult({ baseOffers: Object.entries(groupedResults.baseOffers) })
        }
    }
}

export const filteredResultFunction = (result, searchTerm) => {
    return result?.filter(([serviceName]) =>
        serviceName?.toLowerCase()?.includes(searchTerm.toLowerCase())
    );
}